<template>
  <div class="content ">
  <div class="container add">
		<br>
    <div class="row">
      <div class="col-md-6">
        <label>Номенклатура(название / вес / цена)
					<span  @click="$refs.modal.openModal();" style="color: #00a87d"><b> +</b></span></label>
        <v-select
            label="name"
            :options="nom"
            :reduce="(option) => option"
            v-model="search"
            class="form-group"
            @input="add_pos()"
        >
        </v-select>
        <div v-show="zakaz && zakaz.length>0" class="row" style="color: #125d35">
          <div class="col-1">№</div>
          <div class="col-4">Название</div>
          <div class="col-2">Вес</div>
          <div class="col-2">Цена</div>
          <div class="col-2">Количество</div>
          <div class="col-1">#</div>
        </div>
        <span v-for="(item,key) in zakaz" :key="zakaz.id">
                <div class="row order_table">
                <div class="col-1">{{ key + 1 }}</div>
                <div class="col-4">{{ item.name }}</div>
                <div class="col-2">{{ item.weight }}</div>
                <div class="col-2">{{ item.price }}</div>
                <div class="col-2"><input type="number" v-model="item.number" class="form-control"
                                          @input="change_number(key,item.number)" min="1"
                                          :class="{red_number : item.color==2}"> </div>
                <div class="col-1"><i class="fas fa-trash" @click="del_pos(key)"></i></div>
            </div>
              </span>
        <label class="control-label col-sm-2" for="id">Комментарий:</label>
        <div class="col-md-12">
                        <textarea name="comment" class='form-control' id='comment' v-model="form.comment" cols="50"
                                  rows="10"
                                  placeholder='Примечания к заказу'></textarea>
        </div>
        <br>
        <br>
        <button type="button" class="btn btn-success" v-if="!edit" @click="sendProduct()">Создать</button>
        <button type="button" class="btn btn-success" v-if="edit" @click="sendProduct()">Обновить</button>
        <button type="button" class="btn btn-primary" @click="$router.push('/zakaz')">Отмена</button>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="" style="text-align: center"> Цена: <b>{{ price }}</b></div>
            <br>
            <label class="control-label col-sm-2" for="id">Заказчик:</label>
            <div class="col-md-12">
              <input class="form-control" placeholder='Имя заказчика если есть' v-model="form.fio" name="fio">
            </div>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label col-sm-2" for="id">Филиал:</label>
            <div class="col-md-12">
              <v-select
                  label="name"
                  :options="filials"
                  :reduce="(option) => option.id"
                  v-model="form.fil"
                  class="form-group"
              >
              </v-select>
              <has-error :form="form" field="id"></has-error>
            </div>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label col-sm-2" for="id">Адрес:</label>
            <div class="col-md-12">
              <input class="form-control" placeholder='Укажите адрес если заказчик забирает не сам'
                     v-model="form.adress" name="adress">
            </div>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label col-sm-2" for="id">Телефон:</label>
            <div class="col-md-12">
<!--              <input class="form-control" placeholder='+7 (XXX) XXX-XX-XX' mask='+7 (111) 111 11 11'-->
<!--                     required v-model="form.phone" name="phone">-->

							<the-mask  :mask="'+7 (###)-###-##-##'" id="phone" name="phone"
												 placeholder="Номер для связи" v-model="form.phone"
												 class="form-control"
							/>

						</div>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <label class="control-label col-sm-12">Дата доставки:</label>
            <div class="col-md-12">
              <input type="date" v-model="form.date" class='form-control'>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label col-sm-12" for="id">Время c:</label>
            <div class="col-md-12">
<!--							<time-widget v-model:time="form.timestart"/>-->
<!--							<p>Выбрано время: {{ form.timestart }}</p>-->

              <input type="time" v-model="form.timestart" class='form-control' >
            </div>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label col-sm-12" for="id">Время по:</label>
            <div class="col-md-12">
              <input type="time" v-model="form.timeend" class='form-control' >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label class="control-label col-sm-2" for="id">Статус:</label>
            <div class="col-md-12">
              <select v-model="form.status" class='form-control'>
                <option v-for="stat in status" v-bind:value="stat.value">
                  {{ stat.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label col-sm-4" for="id">Оплата:</label>
            <div class="col-md-12">
              <select v-model="form.oplata" class='form-control'>
                <option v-for="op in oplata" v-bind:value="op.value">
                  {{ op.text }}
                </option>
              </select>
            </div>
          </div>

          <div class=" form-group col-md-3">
            <label class="control-label col-sm-4" for="id">Чек:</label><br>
            <div style="text-align: center">
              <input type="checkbox" id="checkbox" v-model="form.check">
            </div>
          </div>
        </div>
				<div class="row">

				<div class="form-group col-md-6">
          <label class="control-label col-sm-12" for="id">Иные платежи или скидка(отрицательное число):</label>
          <input class="form-control" placeholder='Сумма если есть' v-model="form.anyprice" @input="anyprice"
                 type="number">
        </div>
				<div class="form-group col-md-6">
          <label class="control-label col-sm-12" for="id">Аванс:</label><br>
          <input class="form-control" placeholder='Аванс если есть' v-model="form.avans" @input="anyprice"
                 type="number" style="margin-top: 2em;">
        </div>
      </div>
      </div>
    </div>
		<center-modal-widget
						v-bind:id="'catalog-modal'"
						v-bind:title="'Выберете продукцию'"
						v-bind:is_close="true"
						ref="modal">
			<label>Категория</label>
			<v-select
							label="name"
							:options="categories"
							:reduce="(option) => option.id"
							v-model="category"
							class="form-group"
							@input="loadProduct();product_id=null"
			>
			</v-select>
			<label>Продукт:</label>
			<v-select
							label="name"
							:options="products"
							:reduce="(option) => option"
							v-model="search"
							class="form-group"
							@input="count_form=1"
			>
			</v-select>
			<label>Количество:</label>
			<input class="form-control" type="number" v-model="count_form">

			<br>
			<button type="button" class="btn btn-success left-panel" @click="add_form">Добавить</button>
		</center-modal-widget>

	</div>
	</div>
</template>

<script>
export default {
  props: [
    'id',
  ],
  data() {
    return {
      edit: false,
      keywords: null,
			category: null,
			product_id: null,
			count_form: null,
      results: [],
      zakaz: [],
      number: [],
      filials: [],
			categories: [],
			products: [],
			nom: [],
      price: 0,
      prices: [],
      weight: [],
      status: [
        {text: 'В работе', value: '1'},
        // {text: 'Выполнен', value: '2'},
        {text: 'Клиент', value: '3'},
        // {text: 'Передан курьер', value: '4'}
      ],
      oplata: [
        {text: 'Безнал', value: '1'},
        {text: 'Нал', value: '2'},
        {text: 'Оплачен', value: '3'},
        {text: 'Другое', value: '4'}
      ],
      search: [],
      form: new Form({
        id: '',
        fio: '',
        fil: '',
        adress: '',
        phone: '',
        date: '',
        timestart: '',
        timeend: '',
        status: 1,
        oplata: 1,
        check: '',
        anyprice: '',
        price: '',
        weight: '',
        comment: '',
      }),
      urls: {
        getdata: '/api/zakaz/getzakaz?id=' + this.$route.params.id,
        filial: "/api/filial/list",
        nomenclature: "/api/catalog/any",
        create: "/api/zakaz",
        category: "/api/category/list",
        product: "/api/product/list",
      }
    }
  },

  watch: {
    keywords(after, before) {
      this.fetch();
    }
  },

  methods: {
		handleInput(value) {
			console.log(value)
			if (value.length === 11) {
				value = value.slice(1);
			}
			this.form.phone = value;
		},
    toastError(errors){
      if (errors && errors.length == 1){
        Toast.fire({
          timer: 5000,
          icon: 'error',
          title: errors
        })
      }else{
        var result = Object.keys(errors).map((key) => [errors[key]]);
        for (var i = 0; i < result.length; i++){
          Toast.fire({
            timer: 5000,
            icon: 'error',
            title: result[i][0][0]
          })
        }
      }
    },
    validateErrors(errors){
      if(errors.response &&  errors.response.status==401){
        var error=[];
        error[0]='Истекло время сессии, войдите повторно';
        this.toastError(error);
        window.location.href = "login";
      }
      this.toastError(errors.response.data.errors);
    },
    sum(price, numb, weight) {
      var sum = 0
      var weights = 0
      for (let i = 0; i < price.length; i += 1) {
        sum += price[i] * numb[i];
        weights += weight[i]* numb[i];
      }
      if (this.form.anyprice && this.form.anyprice != null && this.form.anyprice != '' && (sum + parseInt(this.form.anyprice) >= 0)) {
        sum = sum + parseInt(this.form.anyprice);
      }
			if (this.form.avans && this.form.avans != null && this.form.avans != '' && (sum + parseInt(this.form.avans) >= 0)) {
       // sum = sum + parseInt(this.form.avans);
      }
      if (sum + parseInt(this.form.anyprice) < 0) {
        Toast.fire({
          icon: 'error',
          title: 'Иной платеж не может быть больше суммы продуктов'
        });
      }
      this.form.weight=weights;
      return sum;
    },
		add_form(){
			var name = [];
			name = this.search.name.split(' / ');
			var length = this.number.length
			this.prices[length] = this.search.price;
			this.weight[length] = this.search.weight;
			this.number[length] = parseInt(this.count_form);
			this.price = this.sum(this.prices, this.number, this.weight);
			this.zakaz.push({
				id: this.search.id,
				name: name[0],
				weight: this.search.weight,
				price: this.search.price,
				number: parseInt(this.count_form),
				color: 1,
			});
			this.$refs.modal.closeModal()
		},
    add_pos() {
      var name = [];
      name = this.search.name.split(' / ');
      var length = this.number.length
      this.number[length] = this.search.number;
      this.prices[length] = this.search.price;
      this.weight[length] = this.search.weight;
      if (!this.search.number)this.number[length]=1;
      this.price = this.sum(this.prices, this.number, this.weight);

      this.zakaz.push({
        id: this.search.id,
        name: name[0],
        weight: this.search.weight,
        price: this.search.price,
        number: 1,
        color: 1,
      });
    },
    del_pos(key) {
      for (var i = 0; this.zakaz.length; i++) {
        if (key == i) {
          this.zakaz.splice(i, 1);
          this.number.splice(i, 1);
          this.prices.splice(i, 1);
          this.weight.splice(i, 1);
          this.price = this.sum(this.prices, this.number,this.weight);
          return;
        }
      }
    },
    change_number(key, number) {
      if (parseInt(number) <= 0) { //|| number==''
        this.zakaz[key]['number'] = 1;
        return;
      }
      if (number == '') {
        this.zakaz[key]['color'] = 2;
        return;
      }
      this.zakaz[key]['number'] = parseInt(number);
      this.zakaz[key]['color'] = 1;
      this.number[key] = parseInt(number);
      this.price = this.sum(this.prices, this.number,this.weight);
    },
    anyprice() {
      this.price = this.sum(this.prices, this.number,this.weight);
    },
    loadFilials() {
      axios.get(this.urls.filial).then(({data}) => (this.filials = data));
    },
		loadCategories() {
			axios.post(this.urls.category,{
				'st':1
			}).then(({data}) => (this.categories = data.data));
		},
		loadProduct() {
			console.log(this.category);
			axios.post(this.urls.product,{
				'id': this.category
			}).then(({data}) => (this.products = data.data));
		},
    loadNomenclatura() {
      axios.get(this.urls.nomenclature)
          .then(response => {
            this.nom = response.data;
          })
          .catch((errors) => {
            this.toastError(errors.response.data.errors);
          });
    },

    getdata() {
      var prices = [];
      var number = [];
      var weight = [];
      axios.get(this.urls.getdata, {})
          .then(response => {
            var results = response.data.data;
            this.form.id = results.id;
            this.form.fio = results.fio;
            this.form.fil = results.filial;
            if (!results.filial || results.filial == null) {
              this.form.adress = results.adress;
            }
            this.form.phone = results.phone;
            this.form.date = results.date;

            if ( results.timestart!=null){
              var time= results.timestart.split(':');
              this.form.timestart=time[0]+':'+time[1];
            }
            if (results.timeend!=null){
              var time=results.timeend.split(':');
              this.form.timeend=time[0]+':'+time[1];
            }
            this.form.timestart = results.timestart;
            this.form.timeend = results.timeend;

            this.form.status = results.status;
            this.form.oplata = results.oplata;
            this.form.check = results.zakcheck;
            this.form.anyprice = results.anyprice;
            this.form.avans = results.avans;
            this.form.price = results.price;
            this.form.avans = results.avans;
            this.form.comment = results.comment;

            this.zakaz = results.catalog.slice(0);
            this.zakaz.forEach(function callback(value, index) {
              prices[index] = value.price;
              number[index] = value.number;
              weight[index] = value.weight;
            });
            for (var i = 0; prices.length > i; i++) {
              this.prices[i] = prices[i];
            }
            for (var i = 0; number.length > i; i++) {
              this.number[i] = number[i];
            }
            for (var i = 0; weight.length > i; i++) {
              this.weight[i] = weight[i];
            }
            this.price = this.sum(this.prices, this.number,this.weight);
            this.edit=true;
          })
          .catch((errors) => {
            this.$Progress.fail();
            this.validateErrors(errors);
          });

    },
    sendProduct() {
     // console.log(123, this.form);
      var formData = new FormData();

      if ( this.form.timestart!=null){
        var time= this.form.timestart.split(':');
        this.form.timestart=time[0]+':'+time[1];
      }
      if (this.form.timeend!=null){
        var time=this.form.timeend.split(':');
        this.form.timeend=time[0]+':'+time[1];
      }
      axios.post(this.urls.create, formData,{
        params: {
          adress: this.form.adress,
          anyprice: this.form.anyprice,
          busy: this.form.busy,
          check: this.form.check,
          date: this.form.date,
          fil: this.form.fil,
          fio: this.form.fio,
          id: this.form.id,
          oplata: this.form.oplata,
          comment: this.form.comment,
          phone: this.form.phone,
          price: this.price,
          weight: this.form.weight,
          status: this.form.status,
          timeend: this.form.timeend,
          timestart: this.form.timestart,
          zakaz:this.zakaz,
					avans:this.form.avans,
          st: 1
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then((response) => {
           this.$router.push('/zakaz');
          })
          .catch((errors) => {
            this.$Progress.fail();
          //  console.log(errors);
            this.validateErrors(errors);
          });
    }

  },
  created() {
   // console.log(123, this.$route.params.id);
    if (this.$route.params.id>0){
      this.getdata();
    }
    this.loadCategories();
    this.loadFilials();
    this.loadNomenclatura();
  }
}
</script>
<style>
.add{
	font-size: medium;
}
.add .form-control{
	font-size: 16px;
}
.red_number {
  background: #A73661;
  color: white!important;
}

.order_table {
  /*border: 1px solid #ccc;*/
  /*box-shadow: 1px 2px 2px #ccc;*/
}

.search {
  position: relative;
}

.search_form {
  z-index: 700;
  position: absolute;
  inset: 0px auto auto 11px;
  transform: translate3d(0em, 4em, 0px);
}

.search_result {
  background: #FFF;
  border: 1px #ccc solid;
  width: auto;
  border-radius: 1em;
  max-height: 15em;
  overflow-y: scroll;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  box-shadow: rgb(0 145 228 / 9%) 7px 7px 0px 1px;


}

.search_result li {
  list-style: none;
  padding: 5px 10px;
  margin: 0 0 0 0px;
  color: #4f5558;
  border-bottom: 1px #ccc solid;
  cursor: pointer;
  /*text-align: left;*/
  transition: 0.3s;
}

.search_result li:hover {
  background: #8cbfd4;
  color: white;
}

.search_result li:active {
  background: #51b1e3;
  color: white;
}



.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.col-md-6, .col-md-12 {
  padding-top: 0px;
  padding-right: 12px;
  padding-bottom: 0px;
  padding-left: 12px;
}

/*.v-select .dropdown li {*/
/*border-bottom: 1px solid rgba(112, 128, 144, 0.1);*/
/*}*/

/*.v-select .dropdown li:last-child {*/
/*border-bottom: none;*/
/*}*/

/*.v-select .dropdown li a {*/
/*padding: 10px 20px;*/
/*width: 100%;*/
/*font-size: 1.25em;*/
/*color: #3c3c3c;*/
/*}*/

/*.v-select .dropdown-menu .active > a {*/
/*color: #fff;*/
/*}*/
/*.v-select, .v-select * {*/
/*    width: auto;*/
/*    color: black;*/

/*}*/


</style>

